import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { accountIssueApi as API } from '../Apis';

export const AccountIssueDocs: IDocs = {
  title: 'AccountIssue',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.accountIssue',
};

const prepareCall = (stateRequestParameters: any) =>
  API.call.post({
    memberNumber: stateRequestParameters?.memberNumber,
    document: stateRequestParameters?.document,
    name: stateRequestParameters?.name,
    email: stateRequestParameters?.email,
    phoneList: [
      {
        type: 'CELLULAR',
        internationalCode: stateRequestParameters?.cellPhone?.DDI,
        areaCode: stateRequestParameters?.cellPhone?.DDD,
        number: stateRequestParameters?.cellPhone?.number,
      },
    ],
    attachment: stateRequestParameters?.attachment,
  });

export const AccountIssueMachine = GenericMachine(prepareCall, {
  docs: AccountIssueDocs,
  definitions: API.definitions,
});
